import { Branding } from "@org-avp/avp-avengers-geometry-service-api";
import { Brand } from "@org-avp/avp-avengers-user-service-api";

export function convertBrandingToBrand(branding: Branding): Brand {
  return branding as string as Brand;
}

export function convertBrandToBranding(brand: Brand): Branding {
  return brand as string as Branding;
}
